// extracted by mini-css-extract-plugin
export var banner = "_ic-0";
export var closeButton = "_ic-2";
export var greenCheckmark = "_ic-3";
export var hereLink = "_ic-4";
export var titleIcon = "_ic-1";